import withLoader from 'components/hocs/withLoader';
import ProductsTable from './ProductsTable';

const Products: React.FC = () => {
  return <ProductsTable />;
};

export default withLoader(Products);
